import React, { useEffect, useState } from "react";
import {
  createAssessmentsAPIEndpoint,
  EndPoints,
} from "../../../services/AssessmentAPI";
import {
  Button,
  MenuItem,
  Pagination,
  PaginationItem,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TextField,
} from "@mui/material";
import { TableRow } from "@mui/material";
import { TableContainer } from "@mui/material";
import { Paper } from "@mui/material";
import { formatDateTimeLocal } from "../../../context/AuthContext";
import { CenterEndPoints, createGeneralAPIEndpoint } from "../../../services/General";

function Results() {
  const [results, setResults] = useState([]);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [centers, setCenters] = useState([]);
  const [search, setSearch] = useState("");
  const [type, setType] = useState("");
  const [status, setStatus] = useState("");

  const [loading, setLoading] = useState(false);

  const [selectedResult, setSelectedResult] = useState(null);
  const [openDetails, setOpenDetails] = useState(false);

  const fetchResults = async () => {
    setLoading(true);

    try {
      const response = await createAssessmentsAPIEndpoint(
        EndPoints.getResults,
      ).fetch({
        params: {
          search,
          type: type || undefined,
          status: status || undefined,
          page: page + 1,
          pageSize,
        },
      });

      setResults(response.data.items || []);
      setTotalCount(response.data.totalCount || 0);
    } catch (error) {
      console.error("Error fetching results:", error);
      setResults([]);
      setTotalCount(0);
    } finally {
      setLoading(false);
    }
  };
  const fetchCenters = async () => {
    createGeneralAPIEndpoint(CenterEndPoints.all)
    .fetch()
    .then((res) => {
      setCenters(res.data || []);
    })
    .catch((err) => {
      console.error("Failed to fetch centers data:", err);
    });
  }
  const handleViewResult = async (result) => {
    try {
      const response = await createAssessmentsAPIEndpoint(
        EndPoints.getResultDetails(result.assessmentId, result.submissionId),
      ).fetch();

      setSelectedResult(response.data);
      setOpenDetails(true);
    } catch (error) {
      console.error("Error fetching submission details:", error);
    }
  };
  useEffect(() => {
    fetchResults();
  }, [page, pageSize, search, type, status]);
  return (
    <div className = "ResultPage">
  <div className="results-filters">
  <TextField
    label="Search"
    variant="standard"
    value={search}
    onChange={(e) => {
      setPage(0);
      setSearch(e.target.value);
    }}
    className="search-field"
  />

  <TextField
    select
    label="Type"
    value={type}
    onChange={(e) => {
      setPage(0);
      setType(e.target.value);
    }}
    className="result-filter"
  >
    <MenuItem value="">All</MenuItem>
    <MenuItem value="Exam">Exams</MenuItem>
    <MenuItem value="Homework">Homeworks</MenuItem>
  </TextField>

  <TextField
    select
    label="Status"
    value={status}
    onChange={(e) => {
      setPage(0);
      setStatus(e.target.value);
    }}
    className="result-filter"
  >
    <MenuItem value="">All</MenuItem>
    <MenuItem value="Submitted">Submitted</MenuItem>
    <MenuItem value="InProgress">In Progress</MenuItem>
    <MenuItem value="Expired">Expired</MenuItem>
  </TextField>

</div>
      <TableContainer
        component={Paper}
        sx={{ margin: "2rem auto" }}
        className="table-container"
      >
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Student</TableCell>
              <TableCell>Assessment</TableCell>
              <TableCell>Type</TableCell>
              <TableCell>Score</TableCell>
              <TableCell>Percentage</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Submitted At</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {results.length > 0 ? (
              results.map((result) => (
                <TableRow key={result.submissionId}>
                  <TableCell>{result.studentName}</TableCell>

                  <TableCell>{result.assessmentTitle}</TableCell>

                  <TableCell>{result.type === 0? "Exam" : "Homework"}</TableCell>

                  <TableCell>
                    {result.score} / {result.totalPoints}
                  </TableCell>

                  <TableCell>
                    {" "}
                    <span className="result-percentage">
                      {result.percentage}%
                    </span>
                  </TableCell>

                  <TableCell>
                    {" "}
                    <span
                      className={`result-status ${result.status
                        ?.toLowerCase()
                        .replace(" ", "-")}`}
                    >
                      {result.status}
                    </span>
                  </TableCell>

                  <TableCell>
                    {result.submittedAtUtc
                      ? new Date(
                        formatDateTimeLocal(result.submittedAtUtc)
                      ).toLocaleString()
                      : "—"}
                  </TableCell>

                  <TableCell>
                    <Button
                      className="btn-view"
                      onClick={() => handleViewResult(result)}
                    >
                      View
                    </Button>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={8} align="center">
                  No results found.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* <SubmissionDetailsDialog
        open={openDetails}
        onClose={() => {
          setOpenDetails(false);
          setSelectedSubmission(null);
        }}
        submission={selectedSubmission}
      /> */}
      <Pagination
        className="pagination"
        page={page + 1}
        count={Math.ceil(totalCount / pageSize)}
        onChange={(event, newPage) => {
          setPage(newPage - 1);
        }}
        renderItem={(item) => <PaginationItem component="div" {...item} />}
      />
    </div>
  );
}

export default Results;
